import { sortBy } from 'lodash';

import { ICatalog } from '../model/product/ICatalog';

export default function sortCatalogs<T extends ICatalog>(catalogs: T[]) {
    return sortBy(catalogs, ['countryName', 'languageName']);
}
